module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$root.dataReady) ? _c('div', {
    staticClass: "health-and-wellness"
  }, [_c('div', {
    staticClass: "hero"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "bg",
    style: ({
      'background-image': 'url(https://webershandwick.co.uk/wp-content/uploads/2023/07/hero-health-scaled-1.jpeg)',
    })
  })]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6)]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "height": "76",
      "src": "https://webershandwick.co.uk/wp-content/uploads/2023/03/weber_w_logotype_rgb_white.png",
      "width": "76"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "button",
    attrs: {
      "href": "#mc_embed_shell"
    }
  }, [_vm._v("Get in touch")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('h1', {
    staticClass: "aos-init aos-animate",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "500"
    }
  }, [_vm._v("\n          A renewed focus on Health & Wellness\n        ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hero-info"
  }, [_c('h1', {
    staticClass: "aos-init aos-animate",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "500"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "black-text"
  }, [_vm._v("\n      \"We decode today’s health and wellbeing information overload, helping\n      brands rise above the noise and putting people in control of their\n      health journey.\"\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "signature-text"
  }, [_vm._v("\n      Anna Gallais, Managing Director, Consumer Health & Wellness, EMEA\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "video-wrapper"
  }, [_c('iframe', {
    attrs: {
      "src": "https://www.youtube.com/embed/s0WjUdGQfm8?rel=0",
      "width": "100%",
      "height": "100%",
      "frameborder": "0"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "video-description"
  }, [_c('h2', [_vm._v("MEET THE TEAM")]), _vm._v(" "), _c('p', {
    staticClass: "video-description--text"
  }, [_vm._v("\n      Our Consumer Health & Wellness team, comprising specialists across the\n      EMEA region, works with brands offering a diverse range of products and\n      services: from over the counter medication and FMCG, to delivering\n      health benefits and wellbeing apps. Creativity is what drives us and,\n      importantly, it’s what moves people too – explore our work below.\n      "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n      For unique Consumer Health and Wellness insights, view our latest trends\n      report\n      "), _c('a', {
    attrs: {
      "href": "https://webershandwick.co.uk/wp-content/uploads/2023/07/Consumer-Healthcare_Forecast-24-July-2023.pdf",
      "target": "_blank"
    }
  }, [_vm._v("here")]), _vm._v(".\n      "), _c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "video-description--text-bold"
  }, [_vm._v("\n      To learn more, please "), _c('a', {
    attrs: {
      "href": "#mc_embed_shell"
    }
  }, [_vm._v("get in touch")]), _vm._v(" – we\n      would love to hear from you.\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "persons"
  }, [_c('h2', [_vm._v("KEY WORK")]), _vm._v(" "), _c('div', {
    staticClass: "persons-interviews"
  }, [_c('div', {
    staticClass: "person-interview"
  }, [_c('iframe', {
    attrs: {
      "src": "https://player.vimeo.com/video/840080797?h=e4430a6b6f",
      "width": "100%",
      "height": "100%",
      "frameborder": "0"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "person-title"
  }, [_vm._v("The Uncover for Frida")]), _vm._v(" "), _c('p', {
    staticClass: "person-description"
  }, [_vm._v("\n          In France, breastfeeding in public remains controversial. Mothers\n          face harassment every day. Maternity-wear brand, Frida, wanted to\n          normalise and destigmatise breastfeeding. We designed a cover that\n          made breastfeeding as normal as reading a magazine.\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "person-interview"
  }, [_c('iframe', {
    attrs: {
      "src": "https://player.vimeo.com/video/822950191?h=9de1e89d0b",
      "width": "100%",
      "height": "100%",
      "frameborder": "0"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "person-title"
  }, [_vm._v("Field 100 for Dr. Schär")]), _vm._v(" "), _c('p', {
    staticClass: "person-description"
  }, [_vm._v("\n          With 66% of crops coming from just nine species, global food\n          security at risk. We helped Dr Schär cultivate the world’s most\n          biodiverse field as a platform for major research and natural event\n          space for next level field trips.\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "person-interview"
  }, [_c('iframe', {
    attrs: {
      "src": "https://player.vimeo.com/video/670717613?h=225ea7586d",
      "width": "100%",
      "height": "100%",
      "frameborder": "0"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "person-title"
  }, [_vm._v("Coldish for Sensodyne")]), _vm._v(" "), _c('p', {
    staticClass: "person-description"
  }, [_vm._v("\n          Ice-cream is one of the joys of summer but two in five people have\n          sensitive teeth so can’t enjoy it. Sensodyne wanted to start a\n          conversation about summertime oral-sensitivity so we invented\n          Coldish, the world’s first lukewarm ice-cream…\n        ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "mc_embed_shell"
    }
  }, [_c('link', {
    attrs: {
      "href": "//cdn-images.mailchimp.com/embedcode/classic-061523.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "mc_embed_signup"
    }
  }, [_c('form', {
    staticClass: "validate",
    attrs: {
      "action": "https://webershandwick.us21.list-manage.com/subscribe/post?u=cbecd27708abff5429c48ef87&id=8be544c9f2&v_id=152&f_id=00e55fe1f0",
      "method": "post",
      "id": "mc-embedded-subscribe-form",
      "name": "mc-embedded-subscribe-form",
      "target": "_blank"
    }
  }, [_c('div', {
    attrs: {
      "id": "mc_embed_signup_scroll"
    }
  }, [_c('h2', [_vm._v("GET IN TOUCH")]), _vm._v(" "), _c('div', {
    staticClass: "mc-field-group"
  }, [_c('p', [_c('strong', [_vm._v("If you would like to connect with a member of our team and tap into further consumer health & wellness trends and insights, please provide your details below.")])])]), _vm._v(" "), _c('div', {
    staticClass: "indicates-required"
  }, [_c('span', {
    staticClass: "asterisk"
  }, [_vm._v("*")]), _vm._v(" indicates required\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "mc-field-group"
  }, [_c('label', {
    attrs: {
      "for": "mce-EMAIL"
    }
  }, [_vm._v("Email Address "), _c('span', {
    staticClass: "asterisk"
  }, [_vm._v("*")])]), _c('input', {
    staticClass: "required email",
    attrs: {
      "type": "email",
      "name": "EMAIL",
      "id": "mce-EMAIL",
      "required": "",
      "value": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mc-field-group"
  }, [_c('label', {
    attrs: {
      "for": "mce-FNAME"
    }
  }, [_vm._v("First Name "), _c('span', {
    staticClass: "asterisk"
  }, [_vm._v("*")])]), _c('input', {
    staticClass: "required text",
    attrs: {
      "type": "text",
      "name": "FNAME",
      "id": "mce-FNAME",
      "required": "",
      "value": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mc-field-group"
  }, [_c('label', {
    attrs: {
      "for": "mce-LNAME"
    }
  }, [_vm._v("Last Name "), _c('span', {
    staticClass: "asterisk"
  }, [_vm._v("*")])]), _c('input', {
    staticClass: "required text",
    attrs: {
      "type": "text",
      "name": "LNAME",
      "id": "mce-LNAME",
      "required": "",
      "value": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mc-field-group"
  }, [_c('label', {
    attrs: {
      "for": "mce-MMERGE5"
    }
  }, [_vm._v("Job title (incl. organisation) ")]), _c('input', {
    staticClass: "text",
    attrs: {
      "type": "text",
      "name": "MMERGE5",
      "id": "mce-MMERGE5",
      "value": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mergeRow gdpr-mergeRow content__gdprBlock mc-field-group",
    attrs: {
      "id": "mergeRow-gdpr"
    }
  }, [_c('div', {
    staticClass: "content__gdpr"
  }, [_c('label', [_vm._v("Marketing Permissions")]), _vm._v(" "), _c('p', [_vm._v("Please select all the ways you would like to hear from :")]), _vm._v(" "), _c('fieldset', {
    staticClass: "mc_fieldset gdprRequired mc-field-group",
    attrs: {
      "name": "interestgroup_field"
    }
  }, [_c('label', {
    staticClass: "checkbox subfield",
    attrs: {
      "for": "gdpr1320"
    }
  }, [_c('input', {
    staticClass: "gdpr",
    attrs: {
      "type": "checkbox",
      "id": "gdpr_1320",
      "name": "gdpr[1320]",
      "value": "Y"
    }
  }), _c('span', [_vm._v("Email")])])]), _vm._v(" "), _c('p', [_vm._v("\n                You can unsubscribe at any time by clicking the link in the\n                footer of our emails. For information about our privacy\n                practices, please visit our website.\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "content__gdprLegal"
  }, [_c('p', [_vm._v("\n                We use Mailchimp as our marketing platform. By clicking below\n                to subscribe, you acknowledge that your information will be\n                transferred to Mailchimp for processing.\n                "), _c('a', {
    attrs: {
      "href": "https://mailchimp.com/legal/terms"
    }
  }, [_vm._v("Learn more")]), _vm._v("\n                about Mailchimp's privacy practices.\n              ")])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfalse",
    attrs: {
      "id": "mce-responses"
    }
  }, [_c('div', {
    staticClass: "response",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "mce-error-response"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "response",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "mce-success-response"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "left": "-5000px"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('input', {
    attrs: {
      "type": "text",
      "name": "b_cbecd27708abff5429c48ef87_8be544c9f2",
      "tabindex": "-1",
      "value": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }, [_c('input', {
    staticClass: "button",
    attrs: {
      "type": "submit",
      "name": "subscribe",
      "id": "mc-embedded-subscribe",
      "value": "SUBMIT"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-51c0043e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/HealthAndWellness.vue
// module id = 339
// module chunks = 0